import React, { useEffect, useRef } from 'react';

const LANDMARK_CONNECTIONS = [
  [11, 13],
  [13, 15],
  [12, 14],
  [14, 16],
  [11, 12],
  [11, 23],
  [12, 24],
  [23, 25],
  [25, 27],
  [24, 26],
  [26, 28],
  [23, 24]
];

export default function AsanaPreview({ imageUrl, landmarks, size = 50 }) {
  const canvasRef = useRef(null);

  if (!imageUrl) {
    return <div style={{ width: size, height: size, backgroundColor: '#eee' }} />;
  }

  useEffect(() => {
    const canvas = canvasRef.current;
    if (!canvas || !imageUrl) return;

    const ctx = canvas.getContext('2d');
    const image = new Image();
    image.crossOrigin = 'anonymous';

    image.onload = () => {
      canvas.width = size;
      canvas.height = size;

      ctx.clearRect(0, 0, size, size);
      ctx.drawImage(image, 0, 0, size, size);

      if (Array.isArray(landmarks) && landmarks.length > 0) {
        ctx.strokeStyle = '#00FF00';
        ctx.lineWidth = 1;

        LANDMARK_CONNECTIONS.forEach(([start, end]) => {
          const p1 = landmarks[start];
          const p2 = landmarks[end];
          if (p1 && p2) {
            ctx.beginPath();
            ctx.moveTo(p1.x * size, p1.y * size);
            ctx.lineTo(p2.x * size, p2.y * size);
            ctx.stroke();
          }
        });

        ctx.fillStyle = '#FF0000';
        landmarks.forEach((lm) => {
          ctx.beginPath();
          ctx.arc(lm.x * size, lm.y * size, 2, 0, 2 * Math.PI);
          ctx.fill();
        });
      }
    };

    image.onerror = (error) => {
      console.error('Failed to load image:', imageUrl, error);
      // Optionally render a placeholder or error state
      ctx.fillStyle = '#eee';
      ctx.fillRect(0, 0, size, size);
      ctx.fillStyle = '#000';
      ctx.font = '12px Arial';
      ctx.fillText('Image failed to load', 10, size / 2);
    };

    image.src = imageUrl;

    return () => {
      image.onload = null;
      image.onerror = null;
    };
  }, [imageUrl, landmarks, size]);

  return (
    <canvas
      ref={canvasRef}
      width={size}
      height={size}
      style={{
        width: `${size}px`,
        height: `${size}px`,
        borderRadius: '4px',
        cursor: 'pointer',
        display: imageUrl ? 'block' : 'none'
      }}
    />
  );
}
